//
//
//

import Vue from "vue";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import HighlightJs from "@/directives/highlightjs.directive.vue";
import { date } from "quasar";
import AppBreadcrumbs from "@/components/Main/AppBreadcrumbs/app-breadcrumbs.vue";
import UserProfileMenuDialog from "@/components/User/UserProfileMenuDialog.vue";
import TaskListMobile from "@/pages/main/views/TaskList/TaskListMobile.vue";
import AppUserTask from "@/pages/fabricInterface/appUserTask.vue";
import AppListMobile from "@/pages/main/views/Apps/AppListMobile.vue";
import SoftwareLicenses from "@/pages/main/views/SoftwareLicenses/SoftwareLicenses.vue";
import { DiagramValidator } from "@/assets/js/DiagramValidator/diagram-validator";
import QfTree from "@/components/UserInterfaces/components/tree/QfTree.vue";
import SmartContractCodePreview from "@/components/SmartContractDesigner/SCSmartContractCodePreview/SCSmartContractCodePreview.vue";
import { addWindowResizeCallback } from "@/assets/js/appResize";
import store from "@/store";
import { SIDEBAR_BTNS, APP_SUBROUTES_LIST } from "@/pages/main/routerPermissionsConst";
import { $http, checkPermissionsApp, convertAndFormatTimeToLocal, updateWindowTitle, eventBus } from "@/assets/js/appFunc";
import { PAGES_TO_HIDE_SAVE } from "@/pages/main/pagesToHideConst";
import { APP_DATE_DOT_FORMAT, ENGINE_REST_PATH } from "@/assets/js/appConfig";

import VueApexCharts from "vue-apexcharts";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import HelpCenter from "@/components/HelpCenter/HelpCenter.vue";
import UserAccount from "@/components/UserAccount/UserAccount.vue";
import FabDrawerMenu from "../fabricInterface/components/FabDrawerMenu.vue";
import BuilderMenu from "../fabricInterface/components/BuilderMenu.vue";
import UserProfileModal from "../fabricInterface/components/modals/UserProfileModal.vue";
import UserMenuModal from "../fabricInterface/components/modals/UserMenuModal.vue";
import { registerLicense } from "@syncfusion/ej2-base";
import {  key } from "@/pages/main/views/Syncfusion/DiagramConfig";


import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
// Registering Syncfusion license key
registerLicense(key);
Vue.use(VueApexCharts);

Vue.component("QfTree", QfTree);
Vue.component("Apexchart", VueApexCharts);

export default {
    directives: {
        highlightjs: HighlightJs
    },
    components: {
        AppBreadcrumbs,
        UserProfileMenuDialog,
        UserMenuModal,
        FabDrawerMenu,
        BuilderMenu,
        UserProfileModal,
        SmartContractCodePreview,
        TaskListMobile,
        AppUserTask,
        AppListMobile,
        SoftwareLicenses,
        AQTooltip,
        HelpCenter,
        AQButton,
        AQDialog,
        UserAccount,
        AQMenu
    },
    data() {
        return {
            drawer: true,
            hideSaveBtn: true,
            isTasksPageActive: false,
            sideMenu: false,
            menuKey: 0,
            disabledBtn: false,
            showLandscapeMsg: false,
            mainItems: ["dashboard", "administration", "applications", "tasks"],
            buildingItems: ["applications"],
            disableSave: false,
            showMenu: false,
            appMenu: true,
            builderMenu: true,
            timestamp: "",
            brandName: "",
            blockchainTypeApp: false,
            popover: false,
            publishBtnState: false,
            showErrorPublish: false,
            readonlyPermission: false,
            showCheckedSave: false,
            noProcessDisablePublish: false,
            disableDoneStatusReport: false,
            persistSaveBtnState: false,
            availableSidebarBtns: SIDEBAR_BTNS,
            pagesToHideSave: PAGES_TO_HIDE_SAVE,
            appSubroutesList: APP_SUBROUTES_LIST,
            processIdWithError: "",
            publishErrorMsg: "",
            currentAppPage: "",
            maintenanceMessage: "",
            taskIDToBeClaimed: "",
            processNameError: "",
            publishDlg: false,
            processNamesToArchive: "",
            hasSave: {
                label: this.$t("apps.copyBtn")
            },
            defaultLanguage: "en",
            sideBar: [
                {
                    name: "applications",
                    title: this.$t("mainPage.sideBar.appSettings"),
                    icon: "mdi-settings",
                    to: "/settings",
                    display: true,
                    disable: this.disabledBtn
                },
                {
                    name: "diagrams",
                    title: this.$t("mainPage.sideBar.plm"),
                    icon: "mdi-drawing",
                    to: "/diagrams",
                    display: true,
                    disable: this.disabledBtn
                },
                {
                    name: "smartContractDesigner",
                    title: this.$t("mainPage.sideBar.smartcontract"),
                    icon: "mdi-bitcoin",
                    to: "/smartcontract",
                    display: false,
                    disable: this.disabledBtn
                },
                {
                    name: "userInterfaces",
                    title: this.$t("mainPage.sideBar.ui"),
                    icon: "mdi-group",
                    to: "/userInterfaces",
                    display: true,
                    disable: this.disabledBtn
                },
                {
                    name: "documents",
                    title: this.$t("mainPage.sideBar.documents"),
                    icon: "mdi-square-edit-outline",
                    to: "/documentTemplates",
                    display: true,
                    disable: this.disabledBtn
                },
                {
                    name: "apis",
                    title: this.$t("mainPage.sideBar.api"),
                    icon: "mdi-shuffle-variant",
                    to: "/integrations",
                    display: true,
                    disable: this.disabledBtn
                },
                {
                    name: "dataModelMaster",
                    title: this.$t("mainPage.sideBar.dataModel"),
                    icon: "mdi-graphql",
                    to: "/dataModel",
                    display: true,
                    disable: this.disabledBtn
                },
                {
                    name: "reports",
                    title: this.$t("mainPage.sideBar.plv"),
                    icon: "mdi-signal-cellular-3",
                    to: "/analytics",
                    display: true,
                    disable: this.disabledBtn
                }
            ],
            appPermission: {},
            disableOnLoad: false,
            publishInfoGDM: false,
            generalWarningDialog: false,
            dialogObj: {},
            menuCollapsed: false,
            showTransition: false,
            changeHMenu: [],
            moreIcon: require("@/assets/images/Buttons/more.svg"),
            disableCloseSaveHistoryPreview: true,
            saveHistoryRestoreBtn: false,
            disableSaveHistoryRestoreBtn: true,
            saveHistoryCloseBtn: false,
            maintenanceSchedule: false,
            visibleNoteBtn: false,
            previewModePublishBtnMsg: null,
            helpCenterModel:false
        };
    },

    computed: {
        ...mapGetters("main", ["activePage", "lastUpdate", "getShowSaveBtnByPermission", "getInfoApp", "getCurrentApplicationId", "getDisableOnLoad", "interfaceDirty", "getIsOnLoadApplication"]),
        ...mapGetters("apps", ["currentApp", "tempApp", "getCurrentAppUserPermissions", "currentProcess", "processList"]),
        ...mapGetters("apis", ["allConsumedApis", "allExposedApis"]),
        ...mapGetters("components", ["getCurrentInterface"]),
        ...mapGetters("version", ["latestVersionId"]),
        ...mapGetters("smartContractDesigner", ["applicationFunctions", "smartContractValidationModel", "inEditFunction", "appBlockchainLanguage"]),
        ...mapGetters("rules", ["getCurrentRule", "getCurrentLevel", "showRuleTesting", "showInstanceTable", "getTestAllRules"]),
        ...mapGetters("diagrams", ["diagramData", "getProcessWithError"]),
        ...mapGetters("userProfile", ["userCookieInfo", "timestampCookie", "userDataDetails", "getNeedsTaskRedirect"]),
        ...mapGetters("admin", ["appSettingsData", "getAppGroupsInitialData"]),
        ...mapGetters("GDM", ["lastGDMUpdate", "publishStatus"]),
        ...mapGetters("catalogs", ["selectedCat"]),
        ...mapState("components", ["isSmallScreen", "currentInterfaceProperties", "live"]),
        ...mapState("apps", ["userSystemPermissions"]),
        ...mapState("documentEditor", ["selectedDoc"]),
        ...mapGetters("catalogs", ["selectedCat"]),
        ...mapGetters("dataStore", ["getSelectedEntity"]),
        showItem() {
            return this.$route.name && !["appUserTaskDataViews", "appUserTaskAnalytics", "appUserTask"].includes(this.$route.name);
        },
        interfaceName() {
            return this.currentInterfaceProperties ? this.currentInterfaceProperties.name : null;
        },
        getChangeHistoryMenuOps() {
            return [ {label:this.$t('versioning.changeHModalTitle'), name:'changeH' } ]
        },
        documentName() {
            return this.selectedDoc.length ? this.selectedDoc[0].name : null;
        },
        catalogName() {
            return this.selectedCat ? this.selectedCat.name : null;
        },
        processName() {
            return this.currentProcess.name;
        },
        windowName() {
            let wName = "";
            if (this.$route.name === "userInterfaces") {
                wName = this.interfaceName;
            }
            return wName || this.activePageTitle;
        },
        showCancelPreview() {
            return this.$route.name === "userInterfaces" && this.live;
        },
        isWebHelpCompliant() {
            const permissions = this.userSystemPermissions || {};
            return (permissions.A && permissions.A.g) || (permissions.C && permissions.C.g);
        },
        checkDisableOnLoad() {
            return this.getDisableOnLoad;
        },
        activePageTitle() {
            return this.checkActivePage ? (this.currentApp.name || "") : "";
        },
        showErrorPublishSign() {
            const routes = ['ProcessList', 'documents', 'userInterfaces', 'diagrams', 'process', 'dataModel', 'catalogs', 'consumed', 'expose', 'internalApis'];
            return  routes.includes(this.$route.name) && this.showErrorPublish;
        },
        showReadOnlyModeState() {
            const routes = ['StatusReport', 'appsMainPage', 'dashboard', 'myOpenTasks'];
            return this.readonlyPermission && !routes.includes(this.$route.name);
        },
        showPublishButton() {
            const routes = ['ProcessList', 'documents', 'userInterfaces', 'diagrams', 'process', 'dataModel', 'catalogs', 'consumed', 'expose', 'internalApis'];
            return routes.includes(this.$route.name) && !this.showRuleTesting
            || (this.$route.name === 'dataStoreLegacy' && this.publishInfoGDM && this.$oneAtATime.state.$currentRoomEmpty);
        },
        publishButtonLabel() {
            if (this.$route.name === 'dataStoreLegacy') {
                return this.$t("mainPage.publishEntity")
            }
                return this.$t('mainPage.publish')
        },
        saveButton() {
            return !this.isReadOnly && this.showSaveBtn && !this.hideSaveBtn && !this.showRuleTesting && this.showCheckedSave && !this.$route.path.includes("administration");
        },
        swaggerDisabled() {
            return !(
                (this.currentProcess && this.currentProcess.processInformation && this.currentProcess.processInformation.swagger_uuid) ||
                this.currentProcess.swaggerId
            );
        },
        showErrorDetails() {
            return (this.getProcessWithError.id !== this.currentProcess.id && this.$route.name === 'diagrams') || this.$route.name !== 'process';
        },
        lastSave() {
            let timestamp = "";
            let lastSavedDate;
            let updatedModule;
            const routes = ["reports", "processes", "ProcessList", "smartContractList", "useTemplate", "StatusReport", "newSmartContract", "startFromScratch"];
            if (this.lastUpdate.length) {
                updatedModule = this.lastUpdate.find(elem =>
                    this.$route.name === "diagrams" ? elem.processId === this.currentProcess.id : elem.name === this.$route.name
                );

                if (updatedModule) {
                    lastSavedDate = updatedModule.date;
                }
            }
            if (this.lastUpdate && updatedModule && !routes.includes(this.$route.name)) {
                timestamp = this.$t("mainPage.lastSave") + date.formatDate(lastSavedDate.getTime(), "hh:mm A");
            }
            return timestamp;
        },
        lastPublish() {
            let showLastPublish = false;
            if (this.$route.name === "ProcessList") {
                if (this.currentApp.lastPublished) {
                    this.timestamp = convertAndFormatTimeToLocal(this.currentApp.lastPublished, APP_DATE_DOT_FORMAT);
                } else {
                    this.timestamp = this.$t("mainPage.neverPublishTimestamp");
                }
                showLastPublish = true;
            }
            return showLastPublish;
        },
        isReadOnly() {
            return this.getShowSaveBtnByPermission;
        },
        showSaveBtn() {
            let responseSave;
            const pageToShowSave = ["perspectiveBuilder", "userInterfaces"];
            if (pageToShowSave.includes(this.$route.name)) {
                responseSave = true;
            } else if (this.$route.name !== "highlights" || this.interfaceDirty) {
                responseSave = !this.pagesToHideSave.includes(this.$route.name) && this.$oneAtATime.state.$currentRoomEmpty;
            }
            this.showSaveBtnResponse(responseSave);
            return responseSave;
        },
        checkActivePage() {
            const ignoredPages = [...this.mainItems, "processInspector", "dataStoreLegacy", "SoftwareLicenses"];
            return this.activePage && ignoredPages.indexOf(this.activePage) === -1 && this.currentApp.id;
        },
        checkBuilderPage() {
            return this.getIsOnLoadApplication ? !this.getIsOnLoadApplication : (this.activePage && !["components", "accessDenied", "dashboard"].includes(this.activePage) && this.buildingItems.indexOf(this.activePage) === -1 && this.currentApp.id);
        },
        checkNonBuilderPage() {
            return this.getIsOnLoadApplication ? !this.getIsOnLoadApplication : (!this.currentApp.id || ["AddToArchive", "appsMainPage", "accessDenied", "dashboard"].includes(this.$route.name));
        },
        gdmPublishDate() {
            return convertAndFormatTimeToLocal(this.lastGDMUpdate, APP_DATE_DOT_FORMAT);
        },
        statusChip() {
            const color = ["q-ml-xs", "status"];
            if (this.publishStatus === "PUBLISHED") {
                color.push("published");
            } else if (this.publishStatus === "UNPUBLISHED") {
                color.push("unpublished");
            } else if (this.publishStatus === "UNPUBLISHED_CHANGES") {
                color.push("unpublished-changes");
            }
            return color;
        },
        setTooltipContentGDM() {
            let tooltipContent = null;
            if (this.publishStatus === "PUBLISHED") {
                tooltipContent = this.$t("globalDataModel.headerPublishedTooltip");
            } else if (this.publishStatus === "UNPUBLISHED_CHANGES") {
                tooltipContent = this.$t("globalDataModel.headerUnpublishedChangesTooltip");
            }
            return tooltipContent;
        },
        mobileView() {
            return this.isSmallScreen && this.$q.platform.is.mobile;
        },
        isMobileTasksActive() {
            return this.mobileView && this.$route.name && (this.$route.name === "myOpenTasks" || this.$route.path === "/");
        },
        isMobileEditTask() {
            return this.mobileView && this.$route.name === "appUserTask";
        },
        isMobileAppsActive() {
            return this.mobileView && this.$route.name && this.$router.currentRoute.path === "/applications";
        },
        isLicenseActive() {
            return this.mobileView && [this.$router.currentRoute.path, this.$router.history.pending.path].includes("/softwareLicenses");
        },
        checkPublishState() {
            let stateToReturn;
            if(this.$route.name === 'dataStoreLegacy') {
                stateToReturn = this.checkDisableOnLoad;
            } else {
                stateToReturn = !this.publishBtnState || this.noProcessDisablePublish;
            }
            return stateToReturn;
        },
        addExtraBottomSpace() {
            let classToReturn = "";
            if (this.maintenanceSchedule) {
                classToReturn += " add-extra-bottom-space"
            }
            return classToReturn;
        },
        setMenuPadding() {
            let menuClass = "";
            if (this.checkNonBuilderPage && this.showTransition) {
                menuClass = this.menuCollapsed ? 'menu-collapsed' : 'menu-expanded';
            } else if (!this.checkNonBuilderPage) {
                this.showTransition = false;
            }
            if (this.maintenanceSchedule) {
                menuClass += " global-maintenance"
            }
            return menuClass;
        },
        getCatalogPermissions() {
            return this.getCurrentAppUserPermissions && ((this.getCurrentAppUserPermissions.CS && this.getCurrentAppUserPermissions.CS.g === "w" && this.getCurrentAppUserPermissions.CD && this.getCurrentAppUserPermissions.CD.g === "w")
            || this.getCurrentAppUserPermissions.g === "o")
        },
        getDataModelPermissions() {
            return this.getCurrentAppUserPermissions && ((this.getCurrentAppUserPermissions.DM && this.getCurrentAppUserPermissions.DM.g === "w")
            || this.getCurrentAppUserPermissions.g === "o")
        },
        showSaveHistoryBtn() {
            const { name } = this.$route;
            return ((name === 'userInterfaces' && this.interfaceName) || (name === 'documents' && this.documentName)
            || (name === 'catalogs' && this.catalogName && this.getCatalogPermissions) || (name === 'process' && this.processName && !this.showRuleTesting) || (name === "dataModel" && this.getDataModelPermissions))
                && !this.readonlyPermission;
        },
        showChangeHistoryMorebtn() {
            const { name } = this.$route;
            return ((name === 'userInterfaces' && !this.interfaceName) || (name === 'documents' && !this.documentName) || (name === 'dataStore' && !this.getSelectedEntity.code)
            || (name === 'catalogs' && !this.catalogName && this.getCatalogPermissions) || ['ProcessList', "consumed", "expose", "internalApis"].includes(name))
        }
    },
    watch: {
        windowName: {
            handler(value) {
                updateWindowTitle(value || this.brandName);
            },
            immediate: true
        },
        $route(to, from) {
            if (this.getDisableOnLoad && !(to.name === "diagrams")) {
                this.setDisableOnLoad(false);
            }
            let payload;
            const childPriorityUIs = ["highlights", "appSpecificGroups", "appSchedule", "permissions"];
            const availableRouteNames = ["administration", "highlights", "appSchedule", "appSpecificGroups", "permissions"];
            if (to.matched && to.matched.length) {
                to.matched.forEach(elem => {
                    if (childPriorityUIs.indexOf(elem.name) !== -1) {
                        payload = elem.name;
                    }
                    if (availableRouteNames.includes(to.name)) {
                        this.$store.commit("apps/setPath", {
                            path: to.fullPath
                        });
                    }
                });
            }
            if ((to === "/applications" || to === "/") && this.refreshApps) {
                this.getAllApps().then(this.resetRefreshAppsVar);
            }
            if (to.path === "/tasks") {
                this.isTasksPageActive = false;
            }
            this.appsActive = to.path === "/applications";
            if (this.appSubroutesList.includes(to.name)) {
                this.setActivePage(payload || (to.matched && to.matched.length && to.matched[2] ? to.matched[2].name : null));
            } else {
                this.setActivePage(payload || (to.matched && to.matched.length ? to.matched[0].name : null));
            }

            if (this.mainItems.indexOf(this.activePage) !== -1) {
                this.$store.commit("apps/setCurrentApp", {});
            }
            if (to.path !== "/") {
                localStorage.removeItem("isMyTeamDashboard");
            }
            if(from.path === "/" && sessionStorage.getItem("wallet")) {
                sessionStorage.removeItem("wallet");
            }
        },
        "$backendDrivenEvents.state.taskDataNotifications": {
            handler(taskDetails) {
                if (taskDetails) {
                    const splitRequest = taskDetails.split(" : ");
                    const [firstSplitReq, secondSpliReq] = splitRequest;
                    this.taskIDToBeClaimed = "";
                    let checkIsReassign;
                    if (splitRequest.length > 1) {
                        checkIsReassign = firstSplitReq === "reassigned";
                        this.taskIDToBeClaimed = secondSpliReq;
                    }
                    this.$toast.showNotify({
                        type: "info",
                        message: checkIsReassign ? this.$t("tasks.newTaskReassigned") : this.$t("tasks.newTaskAssigned"),
                        buttonLabel: this.$t("tasks.claim"),
                        timeout: 4000,
                        actionEvent: this.notifyClaimAction
                    });
                }
            }
        },
        currentApp: {
            handler(val) {
                if(val) {
                    this.showErrorPublish = false;
                }
                if (val && this.sideBar) {
                    this.sideBar.forEach(elem => {
                        if (val.canManage && elem.name === "smartContractDesigner") {
                            this.blockchainTypeApp = val.blockchainEnabled;
                        }
                    });
                }
            },
            immediate: true
        },
        getCurrentAppUserPermissions(newValue) {
            if (!["appUserTaskDataViews", "appUserTaskAnalytics", "appUserTask"].includes(this.$route.name) && this.currentApp && this.currentApp.id) {
                if (newValue && Object.keys(newValue).length) {
                    const checkInitiator = () => {
                        const { length } = Object.keys(newValue);
                        let hasInitiator;
                        if (length === 1 || (length === 2 && newValue.DP && !Object.keys(newValue.DP).length)) {
                            hasInitiator = true;
                        }
                        return hasInitiator;
                    }
                    if (newValue.hasOwnProperty("I") && checkInitiator()) {
                        this.$router.push("/");
                    } else {
                        let firstAvailableBtn;
                        for (let i = 0; i < this.availableSidebarBtns.length; i++) {
                            if (firstAvailableBtn) {
                                break;
                            } else if (this.$router.history && this.$router.history.pending && this.$router.history.pending.name) {
                                break;
                            } else {
                                const permission = checkPermissionsApp(newValue, this.availableSidebarBtns[i].permissionCode);
                                if (permission) {
                                    this.$route.params.permissions = permission;
                                    firstAvailableBtn = this.availableSidebarBtns[i];
                                }
                            }
                        }

                        if (
                            firstAvailableBtn &&
                            (firstAvailableBtn.permissionCode.parent
                                ? firstAvailableBtn.permissionCode.parent !== "AS"
                                : firstAvailableBtn.permissionCode !== "AS") &&
                            firstAvailableBtn.to !== this.currentAppPage
                        ) {
                            this.currentAppPage = firstAvailableBtn.to;
                            const {name, params, query} = this.$route;
                            if (name === "reports" && firstAvailableBtn.name === "reports" && params.processAnalyticsId) {                                
                                this.$router.push({path: `/applications/${this.currentApp.id}${firstAvailableBtn.to}/${params.processAnalyticsId}`, 
                                    query });
                            } else {                                
                                this.$router.push(`/applications/${this.currentApp.id}${firstAvailableBtn.to}`);
                            }                                                        
                        }
                    }
                } else {
                    this.$router.push("/");
                }
            }
        },
        userDataDetails: {
            handler(newValue) {
                if (newValue && this.userDataDetails.language && this.userDataDetails.language !== localStorage.language) {
                    this.setMultiLanguage();
                }
            },
            immediate: true
        }
    },
    beforeUpdate() {
        const checkVar = localStorage.getItem("taskId");
        if (checkVar !== this.$route.query.id) {
            localStorage.removeItem("conditionType");
            localStorage.removeItem("taskId");
        }
        addWindowResizeCallback({ fn: this.checkWindowSize, ctx: this }, true);
    },
    created() {
        const wrongTenant = JSON.parse(localStorage.getItem("wrongTenantActive"));
        if (!wrongTenant) {
            this.actBrandName().then((data) => {
                this.brandName = data.companyName;
                document.title = data.companyName;
            });
        }
        window.addEventListener("beforeunload", this.pageUnloadPopUp);

        this.$root.$on("changePublishError", () => {
            this.showErrorPublish = false;
        });
        this.$root.$on("showWarningDlg", dialogObj => {
            this.generalWarningDialog = true;
            this.dialogObj = dialogObj;
        });
        this.$root.$on("hideSaveBtn", value => {
            this.hideSaveBtn = value;
        });
        this.$root.$on("setReadonlyTag", value => {
            this.readonlyPermission = value;
        });
        this.$root.$on("showPublish", value => {
            this.noProcessDisablePublish = value.noProcesses;
            this.publishBtnState = value.showPublish === undefined ? false : value.showPublish;
        });
        this.$root.$on("publishBtnWithError", () => {
            this.showErrorPublish = true;
        });
        this.$root.$on("refreshPublishBtnState", value => {
            if(!value) {
                this.noProcessDisablePublish = !this.processList.length;
            }
        })
        this.$root.$on("renderMenu", () => {this.menuKey++; });
        eventBus.$on("renderMenuFromAdmin", () => { this.menuKey++; });

        this.$root.$on("showCheckedSaveBtn", value => {
            this.showCheckedSave = typeof value === 'boolean' ? value : value.showSaveBtn;
            this.persistSaveBtnState = value.persistSaveBtnState
        });
        this.$root.$on("reportView", value => {
            if (value) {
                this.sideBar = this.sideBar.map(elem => {
                    const el = { ...elem };
                    el.disable = el.name !== "reports";
                    return el;
                });
            } else {
                this.sideBar = this.sideBar.map(elem => {
                    const el = { ...elem };
                    el.disable = false;
                    return el;
                });
            }
        });
        this.$root.$on("editView", value => {
            if (this.sideBar) {
                if (value) {
                    this.sideBar = this.sideBar.map(elem => {
                        const el = { ...elem };
                        el.disable = el.name === "reports";
                        return el;
                    });
                } else {
                    this.sideBar = this.sideBar.map(elem => {
                        const el = { ...elem };
                        el.disable = false;
                        return el;
                    });
                }
            }
        });

        this.$root.$on("smartContractDesignerSave", () => {
            if (this.inEditFunction) {
                const validator = new DiagramValidator(this.smartContractValidationModel);
                const result = validator.validate(this.inEditFunction.diagramData);
                if (result && !result.valid && result.errors.length > 0) {
                    this.$store.commit("smartContractDesigner/setDiagramError", true);
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("smartContract.main.diagramError")
                    });
                    return;
                }
                this.$store.commit("smartContractDesigner/setDiagramError", false);
            }
            this.$store.commit("smartContractDesigner/setIndexesForCurrentFunction");
            if (this.currentApp && Object.keys(this.currentApp).length > 0) {
                this.saveFunctionContract(this.inEditFunction).then(
                    () => {
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("generic.savedSuccessfully"),
                            timeout: 500
                        });
                        this.$store.commit("smartContractDesigner/setSaveDigramaData", true);
                        window.localStorage.setItem("funtionInEdit", JSON.stringify(this.inEditFunction));
                        this.$store.commit("main/setInterfaceDirty", false);
                    },
                    () => {
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("generic.saveUnsuccessful"),
                            timeout: 1000
                        });
                    }
                );
                this.$store.commit("smartContractDesigner/flattenInEditFunction");
            }
        });

        this.$root.$on("appsMainPageSave", () => {
            this.$store.commit("main/setInterfaceDirty", false);
            this.addEditApp(this.currentApp).then(data => {
                if (data && data.id) {
                    this.$store.commit("apps/setCurrentApp", data);
                    this.$store.commit("apps/addNewApp", data);
                    this.$store.commit("main/setCurrentApplicationId", data.id);
                    this.$store.dispatch("admin/actionGetGroupsApps");
                    this.$root.$emit("checkUserOnApp", { name: "highlights", appId: data.id });
                    this.$backendWebsocketEvents.startWebsocket(data.id);
                    this.$router.push(`/applications/${data.id}/processes`);
                }
            });
        });
        this.$root.$on("disableSaveButton", value => {
            this.disableSave = value;
        });
        this.$root.$on("recalculateSidebar", data => {
            this.sideBar = this.sideBar.forEach(elem => {
                const el = { ...elem };
                el.display = data.indexOf(elem.name) !== -1;
                return el;
            });
        });
        this.$root.$on("oneAtATime-statusReportMark", () => {
            this.disableDoneStatusReport = !this.$oneAtATime.state.$currentRoomEmpty;
        });
        this.$root.$on("statusReportCreated", () => {
            this.disableDoneStatusReport = false;
        });
        this.$root.$on("showPublishData", value => {
            this.publishInfoGDM = value;
        });
        this.$root.$on("previewSaveHistoryLoadStart", routeName => {
            if (this.$route.name === routeName) {
                this.saveHistoryRestoreBtn = true;
                this.saveHistoryCloseBtn = true;
            }
        });
        this.$root.$on("previewSaveHistoryLoadEnd", routeName => {
            if (this.$route.name === routeName) {
                this.disableSaveHistoryRestoreBtn = false;
                this.disableCloseSaveHistoryPreview = false;
                this.visibleNoteBtn = true;
                this.previewModePublishBtnMsg = this.$t("versioning.noPublishWhilePreview");
            }
        });
        this.$root.$on("previewSaveHistoryHeaderClose", routeName => {
            if (this.$route.name === routeName) {
                this.closeSaveHistoryPreviewHeader();
            }
        });
        this.$root.$on("confirmRestore", routeName => {
            if (this.$route.name === routeName) {
                this.saveHistoryRestoreBtn = false;
                this.saveHistoryCloseBtn = false;
                this.visibleNoteBtn = false;
            }
        })
        this.$root.$on("maintenanceScheduled", () => {
            this.maintenanceSchedule = JSON.parse(localStorage.getItem("maintenanceSchedule"));
            this.maintenanceMessage = localStorage.getItem("maintenanceMessage");
        });
        this.$root.$on("maintenanceStarted", () => {
            if (localStorage.getItem("maintenanceUser") !== "true") {
                $http({ url: "/auth/logout", type: "GET"}, true)
                    .then(() => {
                        window.location.href = "/";
                    })
                    .catch(() => {
                        window.location.href = "/";
                    });
            }
        });
    },
    mounted() {
        if (sessionStorage.getItem("interfaceClosed") === "true") {
            this.$toast.showNotify({
                type: "error",
                message: this.$t("tasks.taskNotAvailable")
            });
            sessionStorage.removeItem("interfaceClosed");
        }
        this.maintenanceSchedule = JSON.parse(localStorage.getItem("maintenanceSchedule"));
        this.maintenanceMessage = localStorage.getItem("maintenanceMessage");
        this.createSmartContractValidationModel();
        this.getFeaturesByTenant();
        window.addEventListener("scroll", this.handleScroll);

        const htmlView = document.getElementsByTagName("html")[0];
        addWindowResizeCallback({ fn: this.checkWindowSize, ctx: this }, true);
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.showLandscapeMsg = window.innerHeight < window.innerWidth;
        }
        if (this.isSmallScreen) {
            htmlView.style.position = "fixed";
        }
        window.addEventListener("dragover", (e) => { e.preventDefault(); }, false);
        window.addEventListener("drop", (e) => { e.preventDefault(); }, false);
        window.addEventListener("orientationchange", this.checkOrientation);
    },
    beforeDestroy() {
        this.$root.$off("changePublishError");
        this.$root.$off("showPublish");
        this.$root.$off("showCheckedSaveBtn");
        this.$root.$off("hideSaveBtn");
        this.$root.$off("reportView");
        this.$root.$off("editView");
        this.$root.$off("smartContractDesignerSave");
        this.$root.$off("highlightsSave");
        this.$root.$off("setReadonlyTag");
        this.$root.$off("disableSaveButton");
        this.$root.$off("recalculateSidebar");
        this.$root.$off("statusReportCreated");
        this.$root.$off("showWarningDlg");
        this.$root.$off("renderMenu");
        this.$root.$off("maintenanceScheduled");
        this.$root.$off("maintenanceStarted");
        this.$root.$off("previewSaveHistoryLoadStart");
        this.$root.$off("previewSaveHistoryLoadEnd");
        this.$root.$off("confirmRestore");
        this.$root.$off("publishBtnWithError");
        eventBus.$off("renderMenuFromAdmin");
        window.removeEventListener("orientationchange", this.checkOrientation);
        window.removeEventListener("beforeunload", this.pageUnloadPopUp);
    },
    methods: {
        ...mapGetters("smartContractDesigner", ["getDiagramError"]),
        ...mapMutations("main", ["setLastUpdate", "setActivePage", "setInterfaceDirty", "setDisableOnLoad"]),
        ...mapMutations("userProfile", ["setUserDetails"]),
        ...mapActions("apps", ["addEditApp", "setCurrentApp", "getAllApps", "updateProcessInstance", "actMarkForArchiving", "getAppProcesses", "getAppSettingsInfo"]),
        ...mapActions("userProfile", ["getUserDetails"]),
        ...mapActions("apis", ["saveConsumedApi", "saveExposedApi", "updateConsumedApi", "getAllConsumedApis"]),
        ...mapActions("admin", ["getFeaturesByTenant", "actionGetGroupsApps", "getRolesForUser"]),
        ...mapActions("version", ["getLatestVersionId"]),
        ...mapActions("smartContractDesigner", ["saveFunctionContract", "createSmartContractValidationModel", "downloadSwagger"]),
        ...mapActions("main", ["getMultiFeaturesOption", "actBrandName"]),
        ...mapMutations("apps", ["updateCurrentAppInfo", "setLastPublish"]),
        ...mapMutations("smartContractDesigner", ["setIndexesForCurrentFunction", "flattenInEditFunction"]),
        ...mapMutations("rules", [
            "setTestAllRules",
            "setShowRuleTesting",
            "setBackToDiagram",
            "setShowInstanceTable",
            "setCurrentLevel",
            "setCurrentRule",
            "setSelectedCondition"
        ]),
        ...mapMutations("components", ["setIsSmallScreen", "setLive"]),
        restorePreviousInterface() {
            this.$root.$emit("restore")
        },
        pageUnloadPopUp(evt) {
            if (this.interfaceDirty && !this.generalWarningDialog) {
                evt.returnValue = true;
            }
            return evt;
        },
        openNoteDialog(routeName) {
            this.$root.$emit("openNoteDialog", routeName)
        },
        openChangeHistory(routeName) {
            this.$root.$emit("openChangeHistory", routeName)
        },
        openSaveHistory(routeName) {
            this.$root.$emit("openSaveHistory", routeName);
        },
        setLogo() {
            return `/identity/companyInfo/logo/header`;
        },
        showSaveBtnResponse(responseSave) {
            this.hideSaveBtn = !this.$route.name || !responseSave;
        },
        btnClasses(pageName) {
            const defs = ["row", "content-padding"];
            const childPriorityUI = { applications: ["highlights"] };
            if (this.activePage === pageName || (childPriorityUI[pageName] && childPriorityUI[pageName].indexOf(this.activePage) !== -1)) {
                defs.push("active");
            }
            return defs;
        },
        goToDashboard() {
            this.$router.push("/");
        },
        showErrorCard(event) {
            this.showMenu = true;
        },
        goToHelp() {
            if (this.helpCenterModel) {
                this.helpCenterModel = false;
            }
            setTimeout(()=> {
                this.helpCenterModel = true;
            }, 0);
        },
        notifyClaimAction() {
            const filter = {
                activeTasks: true,
                isTeam: false,
                page: 0,
                searchTerm: this.taskIDToBeClaimed,
                size: 10,
                sortDirection: "DESC",
                sortField: "creationDate",
                taskFilterModel: {}
            };
            store()
                .dispatch("tasks/getAllTasks", filter)
                .then(data => {
                    if (data && data.tasks.length) {
                        window.localStorage.setItem("taskId", this.taskIDToBeClaimed);
                        store()
                            .dispatch("components/claimTask", data.tasks[0].id)
                            .then(rsp => {
                                if (rsp) {
                                    const [firstTask] = data.tasks;
                                    firstTask.canUnclaim = rsp.data.canUnclaim;
                                    firstTask.__dashboard = true;
                                    firstTask.taskId = firstTask.id;
                                    this.$router.push({ path: `/tasks/${firstTask.taskId}`});
                                }
                            });
                    } else {
                        window.localStorage.setItem("taskId", this.taskIDToBeClaimed);
                        window.localStorage.setItem("conditionType", false);
                        window.location.assign(`/${PLATFORM_BASE_PATH}/task?id=${this.taskIDToBeClaimed}`);
                    }
                });
        },
        checkWindowSize(size = window.innerWidth) {
            if (size < this.$q.screen.sizes.sm) {
                if (!this.isSmallScreen) {
                    this.setIsSmallScreen(true);
                    localStorage.setItem("localIsSmallScreen", true);
                }
            } else if (this.isSmallScreen && !this.showLandscapeMsg) {
                this.setIsSmallScreen(false);
                localStorage.removeItem("localIsSmallScreen");
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
            this.previewCode = false;
        },
        checkOrientation() {
            if (navigator.userAgent.match("CriOS")) {
                this.showLandscapeMsg = window.innerHeight < window.innerWidth
                    || (window.innerHeight > window.innerWidth && window.innerWidth / window.innerHeight < 9 / 13);
            } else {
                this.showLandscapeMsg = window.innerHeight > window.innerWidth
                    || (window.innerHeight < window.innerWidth && window.innerHeight / window.innerWidth > 9 / 13);
            }
        },
        spaSave() {
            this.$root.$emit(`${this.$route.name}Save`);
            if (this.activePage === "administration") {
                this.$root.$emit("saveLabsFeatures");
            }
            if (this.currentApp && this.currentApp.id) {
                let behaviour = "";
                if (this.$route.name === "dataModel" || this.$route.name === "catalogs") {
                    behaviour = "Save Data Model and Catalogs";
                } else if (this.$route.name === "apis") {
                    behaviour = "Save APIs";
                } else if (this.$route.name === "documents") {
                    behaviour = "Save Document";
                } else if (this.$route.name === "userInterfaces") {
                    behaviour = "Save Interface";
                } else if (this.$route.name === "diagrams" || this.$route.path === "/syncfusion") {
                    behaviour = "Save Diagram";
                } else if (this.$route.name === "highlights") {
                    behaviour = "Save Application Settings";
                }

                const payload = {
                    processDefinitionId: (this.$route.name === "diagrams" || this.$route.name === "process") ? this.currentProcess.id : "",
                    applicationId: this.currentApp.id,
                    behaviour
                };
                if(!this.persistSaveBtnState) {
                    this.updateProcessInstance(payload).then(() => {
                        if(this.$route.name !== "schedule" && this.$route.name !== "highlights" && this.$route.name !== "appSchedule" && this.$route.name !== "dataModel"
                        && this.$route.name !== "catalogs") {
                            this.showCheckedSave = true;
                        }
                });
                }
            }
            if( this.$route.name !== "userInterfaces") {
                this.setLastUpdate({date: new Date(), name: this.$route.name, processId: this.currentProcess.id});
            }
            if( this.$route.name === "schedule" || this.$route.name === "appSchedule"){
                this.$root.$emit("saveSchedule");
            }
        },
        activateApp() {
            if (this.$route.name === "dataStoreLegacy") {
                this.$root.$emit("publishEntity");
            } else {
                this.publishApp();
            }
        },
        generateErrorMsg(errorData, extraData) {
            if (errorData.id) {
                const { id, message, type, name } = errorData;
                const tooltipNewMesage = message.includes(id) ? message.split(id) : message;
                this.processIdWithError = extraData && extraData.processDefinitionId ? extraData.processDefinitionId  : id;
                if (tooltipNewMesage) {
                    if (type === "START_BLOCKCHAIN_EVENT_PLUGIN") {
                        this.publishErrorMsg = name && tooltipNewMesage.length
                            ? this.$t("diagrams.components.setBlockchain.startFromBkActivity") + tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                    }
                    else if (type !== "PROCESS_PLUGIN") {
                        this.publishErrorMsg = name && tooltipNewMesage.length
                            ? name + tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                    } else if(name) {
                        this.publishErrorMsg = tooltipNewMesage.length
                            ? tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                    } else {
                        this.publishErrorMsg = tooltipNewMesage;
                    }

                    if (this.publishErrorMsg === "Exclusive gateway") {
                        this.publishErrorMsg = this.$t("mainPage.exclusiveGatewayError");
                    }
                } else {
                    this.publishErrorMsg = errorData.message;
                }
            } else if (extraData && extraData.processDefinitionId) {
                this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm: "" }).then(rsp => {
                    this.processNameError = rsp.data.find(el => el.id === this.processIdWithError).name
                })
                this.processIdWithError = extraData.processDefinitionId;
                this.publishErrorMsg = errorData;
            } else {
                this.processIdWithError = "";
                this.publishErrorMsg = errorData;
            }
        },
        viewProcessWithError() {
            this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm: "" }).then(rsp => {
                let elem = rsp.data.find(el => el.id === this.processIdWithError)
                if(elem) {
                    this.$store.commit("apps/setCurrentProcess", elem);
                    this.$store.commit("main/setCurrentProcessId", elem.id);
                    this.showMenu = false;
                    this.$store.commit("diagrams/setCopyOfInitialContentDiagram", []);
                    this.$store.commit("diagrams/setCopyOfInitialConnectorsDiagram", []);
                    this.$store.commit("diagrams/setCopyOfInitialMessagesDiagam", []);
                    if (this.$route.name === "process") {
                        this.$refs.popoverRef.hide();
                    } else {
                        this.$router.push(`/applications/${this.currentApp.id}/processes/${elem.id}`);
                    }
                }
            })
        },
        statusReportDone() {
            if (this.currentProcess.markedForArchive) {
                this.$router.replace("/processes");
            } else {
                sessionStorage.setItem("wsActionUser", true);
                this.actMarkForArchiving(this.currentProcess.id)
                    .then(() => {
                        this.$router.replace("/processes");
                    })
                    .catch(() => {
                        sessionStorage.removeItem("wsActionUser");
                    });
            }
        },
        statusReportCancel() {
            this.$router.push("/processes");
        },
        closePreview() {
            this.setLive(false);
        },
        backToDiagram() {
            if (this.showInstanceTable) {
                this.$store.commit("rules/setShowInstanceTable", false);
            } else if (this.getTestAllRules) {
                this.$store.commit("rules/setTestAllRules", false);
                this.$store.commit("rules/setCurrentLevel", {});
                this.$store.commit("rules/setCurrentRule", {});
                this.$store.commit("rules/setShowRuleTesting", false);
            } else {
                this.$root.$emit("openSelectedLevel", this.getCurrentLevel);
                if (!Object.entries(this.getCurrentLevel).length) {
                    this.$store.commit("rules/setBackToDiagram", true);
                }
                this.$store.commit("rules/setShowRuleTesting", false);
            }
            this.$store.commit("rules/setSelectedCondition", "");
        },
        setMultiLanguage() {
            this.getMultiFeaturesOption().then(data => {
                const multiLanguageObj = data.data.find(item => item.code === "ALLOW_MULTILANGUAGE");
                if (multiLanguageObj.enabled) {
                    if (this.userCookieInfo.language && localStorage.changedFlag === "true") {
                        if (this.userCookieInfo.language !== localStorage.language) {
                            this.$i18n.locale = localStorage.language;
                        } else {
                            const lang = this.userCookieInfo.language;
                            this.$i18n.locale = lang;
                            localStorage.setItem("language", lang);
                        }
                    } else {
                        this.$i18n.locale = this.userDataDetails.language;
                        localStorage.setItem("language", this.userDataDetails.language);
                    }
                } else {
                    this.$i18n.locale = this.defaultLanguage;
                    localStorage.setItem("language", this.defaultLanguage);
                }
                this.menuKey++;
            });
        },
        publishApp() {
            this.processNamesToArchive = "";
            this.processList.forEach(el => {
                if (el.markedForArchive) {
                    this.processNamesToArchive += this.processNamesToArchive ? ", " + el.name : el.name;
                }
            });
            sessionStorage.setItem("wsActionUser", true);
            this.publishDlg = true;
        },
        okPublishDlg() {
            $http(
                {
                    url: `/engine/api/application/${this.getCurrentApplicationId}/activate`,
                    type: "GET",
                    noNotify: true,
                    data: ""
                },
                true
            ).then(
                response => {
                    this.showErrorPublish = false;
                    if(this.currentProcess) {
                        this.currentProcess.error = false;
                        this.currentProcess.errorOnPublish = null;
                    }
                    this.$store.commit("diagrams/setProcessWithError", {});
                    this.$store.commit("apps/setCurrentProcess", this.currentProcess);
                    let rspProcessList = [];
                    for (let i = 0; i < response.data.length; i++) {
                        const { processDefinitionDTO } = response.data[i];
                        rspProcessList.push(processDefinitionDTO);
                        let current = this.processList.find(elem => elem.id === processDefinitionDTO.id);
                        if (current) {
                            current.status = processDefinitionDTO.publishStatus;
                            if (processDefinitionDTO.parameters) {
                                current.processInformation = processDefinitionDTO.parameters.processInformation;
                            }
                            this.timestamp = convertAndFormatTimeToLocal(processDefinitionDTO.lastPublished, APP_DATE_DOT_FORMAT);
                        }
                        this.currentApp.publishStatus = processDefinitionDTO.publishStatus;
                        this.currentApp.iteration = processDefinitionDTO.iteration;
                        if (processDefinitionDTO.id === this.currentProcess.id) {
                            const getCurrentProcess = current ? { ...current } : {};
                            this.$store.commit("apps/setCurrentProcess", getCurrentProcess);
                        }
                    }
                    this.$store.commit(
                        "apps/setProcessList",
                        this.processList.filter(el => rspProcessList.find(elem => el.id === elem.id))
                    );
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("diagrams.appActivated")
                    });
                    this.$root.$emit("expandErrorCard", false);
                    this.$root.$emit("showErrorCard");

                    const removeOffSet = new Date().setHours(new Date().getHours() + new Date().getTimezoneOffset() / 60);
                    this.setLastPublish(new Date(removeOffSet).toLocaleString());
                },
                error => {
                    sessionStorage.removeItem("wsActionUser");
                    let diagramData;
                    this.showErrorPublish = true;
                    if (error && error.response && error.response.data && error.response.data.error) {
                        let errorData;
                        try {
                            errorData = JSON.parse(error.response.data.error);
                        } catch (e) {
                            errorData = error.response.data.error;
                        }
                        if (error.response.data.extraData) {
                            const processId = error.response.data.extraData.processDefinitionId;
                            if (processId) {
                                for (let i = 0; i < this.processList.length; i++) {
                                    if (processId === this.processList[i].id) {
                                        this.processList[i].error = true;
                                        this.processList[i].errorOnPublish = errorData;
                                        this.$store.commit("diagrams/setProcessWithError", this.processList[i]);
                                        if(this.currentProcess.id === processId) {
                                            this.currentProcess.error = true;
                                            this.currentProcess.errorOnPublish = errorData;
                                            this.$store.commit("apps/setCurrentProcess", this.currentProcess);
                                            this.$root.$emit("expandErrorCard", true);
                                            this.$root.$emit("showErrorCard");
                                        }

                                        this.$store.commit("apps/setProcessList", [...this.processList]);
                                    }
                                }
                            }
                        }
                        this.generateErrorMsg(errorData, error.response.data.extraData);
                        this.getAppSettingsInfo(this.currentApp).then(data => {
                            this.currentApp.publishStatus = data.data.publishStatus;
                            this.$store.commit("apps/setCurrentApp", this.currentApp);
                        });
                        this.showMenu = true;
                    }
                }
            );
        },
        okWarningDialog() {
            if (this.dialogObj.diagramState.length) {
                this.$store.commit("diagrams/setDiagramStateModifications", []);
            }
            if (this.dialogObj.path === "/userInterfaces") {
                this.$root.$emit("refreshInterface");
            }
            if (this.dialogObj.path === "/administration/branding") {
                this.$root.$emit("resetBrandingPage");
            }

            if (this.dialogObj.name === "dataStoreLegacy") {
                this.$root.$emit("refreshDataStoreLegacy");
            }
            if (this.dialogObj.name === "dataStore") {
                this.$root.$emit("refreshdataTables");
            }
            this.$store.commit("diagrams/setCopyOfInitialContentDiagram", []);
            this.$store.commit("main/setInterfaceDirty", false);
            this.dialogObj.next();
        },
        closeSaveHistoryPreviewHeader() {
            this.disableCloseSaveHistoryPreview = true;
            this.saveHistoryRestoreBtn = false;
            this.disableSaveHistoryRestoreBtn = true;
            this.saveHistoryCloseBtn = false;
            this.visibleNoteBtn = false;
            this.previewModePublishBtnMsg = null;
        },
        closeSaveHistoryPreview(routeName) {
            this.$root.$emit("previewSaveHistoryClose", routeName);
            this.closeSaveHistoryPreviewHeader();
        }
    }
};
